export const DEFAULT_DEV_USERNAME = 'admin'
export const DEFAULT_DEV_PASSWORD = 'Qcyy@2026!'
export const DEFAULT_EXPERIENCE_PASSWORD = 'Qcyy666888#'
const LAST_DEV_ACCOUNT_KEY = 'qcyy:last-dev-account'

export const AUTH_EXPIRED_EVENT = 'qcyy-auth-expired'

// 后台快捷登录只保留管理后台角色，合作生态和飞手入口由小程序承载。
export const DEV_QUICK_ACCOUNTS = [
    {username: 'admin', password: DEFAULT_DEV_PASSWORD, label: '超级管理员'},
    // 与体验会议文档保持一致，避免本地快捷登录继续传播已退役的英文别名账号。
    {username: '13800000011', password: DEFAULT_EXPERIENCE_PASSWORD, label: '销售A'},
    {username: '13800000021', password: DEFAULT_EXPERIENCE_PASSWORD, label: '项目经理A'},
    {username: '13800000031', password: DEFAULT_EXPERIENCE_PASSWORD, label: '财务A'},
    {username: '13800000041', password: DEFAULT_EXPERIENCE_PASSWORD, label: '运营A'},
    {username: '13600000023', password: DEFAULT_EXPERIENCE_PASSWORD, label: '销售B'},
]

export function isDevelopmentMode() {
    return process.env.NODE_ENV === 'development'
}

export function isDevAutoLoginEnabled() {
    return isDevelopmentMode() && process.env.VUE_APP_DEV_AUTO_LOGIN !== 'false'
}

function findQuickAccount(username) {
    return DEV_QUICK_ACCOUNTS.find((account) => account.username === username)
}

function readRememberedAccount() {
    if (!isDevelopmentMode()) {
        return null
    }
    try {
        const rawValue = window.localStorage.getItem(LAST_DEV_ACCOUNT_KEY) || ''
        if (!rawValue) {
            return null
        }
        if (rawValue.startsWith('{')) {
            const parsed = JSON.parse(rawValue)
            return parsed.username ? {
                username: parsed.username,
                password: parsed.password || DEFAULT_DEV_PASSWORD,
                label: parsed.label || parsed.displayName || parsed.username,
            } : null
        }
        return findQuickAccount(rawValue)
    } catch (error) {
        return null
    }
}

function configuredDefaultAccount() {
    const username = process.env.VUE_APP_DEV_LOGIN_USERNAME || DEFAULT_DEV_USERNAME
    const password = process.env.VUE_APP_DEV_LOGIN_PASSWORD || DEFAULT_DEV_PASSWORD
    return {username, password, label: username === DEFAULT_DEV_USERNAME ? '超级管理员' : '环境变量账号'}
}

export function rememberDevLoginAccount(account) {
    if (!isDevelopmentMode() || !account?.username) {
        return
    }
    try {
        window.localStorage.setItem(LAST_DEV_ACCOUNT_KEY, JSON.stringify({
            username: account.username,
            password: account.password || DEFAULT_DEV_PASSWORD,
            label: account.label || account.displayName || account.username,
        }))
    } catch (error) {
        // 开发辅助信息写入失败不影响正常登录流程。
    }
}

export function getPreferredDevLoginAccount() {
    if (!isDevelopmentMode()) {
        // 正式构建不得把开发快捷账号带入登录表单，账号和密码必须由用户主动输入。
        return {username: '', password: '', label: ''}
    }
    const rememberedAccount = readRememberedAccount()
    return rememberedAccount || configuredDefaultAccount()
}
